// extracted by mini-css-extract-plugin
module.exports = {"agreement":"_772e1b1e50--agreement--pfIXj","label":"_772e1b1e50--label--ifhXo","link":"_772e1b1e50--link--CMTwJ"};